export const EscapeRouteType = {
    ESCAPE_ROUTE: 1, // 消防通道
    OTHER: 99999, // 其他
}